import { JetView } from 'webix-jet'; // Importing JetView for creating a Webix view
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing Webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a filter view for withdrawal requests.
 * @extends JetView
 */
export default class FilterWithdrawalRequestView extends JetView {
    /**
     * Configures the layout of the filter view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration
        const center_left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Text input for date selection
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for datepicker
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'richselect', // Dropdown for state selection
                            name: 'State',
                            localId: 'bonusStates:combo',
                            label: "<span class='icon-state'></span>" + _('Estado'), // Label for state dropdown
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                // Options for state selection
                                {
                                    id: '',
                                    value: _('Todos'), // All states option
                                },
                                {
                                    id: 'A',
                                    value: _('Activo'), // Active state option
                                },
                                {
                                    id: 'I',
                                    value: _('Inactivo'), // Inactive state option
                                },
                                {
                                    id: 'R',
                                    value: _('Rechazado'), // Rejected state option
                                },
                                {
                                    id: 'P',
                                    value: _('Pendiente'), // Pending state option
                                },
                                {
                                    id: 'E',
                                    value: _('Eliminado'), // Deleted state option
                                },
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Text input for IP address
                            name: 'Ip',
                            label: "<span class='icon-ip'></span>" + _('Direccion IP'), // Label for IP input
                            labelPosition: 'top',
                            placeholder: _('Direccion IP '), // Placeholder text
                        },
                        {
                            view: 'richselect', // Dropdown for payment methods
                            name: 'PaymentMethods',
                            label: "<span class='icon-credit-card'></span>" + _('Formas de Pago'), // Label for payment methods dropdown
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                // Options for payment methods
                                {
                                    id: '0',
                                    value: _('Todos'), // All payment methods option
                                },
                                {
                                    id: '1',
                                    value: _('Efectivo'), // Cash payment option
                                },
                                {
                                    id: '2',
                                    value: _('Cuenta Bancaria'), // Bank account option
                                },
                                {
                                    id: '3',
                                    value: _('Giro Bancario'), // Bank transfer option
                                },
                            ],
                        },
                        { id: 'grav2', gravity: 1 }, // Gravity for layout adjustment
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 250 : 0, // Conditional height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [center_left], // Including the center_left layout
                },
            ],
        };
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Button to clear the form
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clear form values
                    },
                },
                {
                    view: 'button', // Button to submit the filter
                    value: _('Consultar'),
                    hotkey: 'enter', // Enter key to trigger this button
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('bonusReport:filter', [filterdata]); // Trigger filter event
                        $$('b5').collapse(); // Collapse the accordion section
                    },
                },
            ],
        };
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filters
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for the accordion
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Including upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        return {
            view: 'form', // Main view type
            type: 'clean',
            rows: [accordion_section], // Including the accordion section
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for form
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid object passed to the init function.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav2').hide(); // Hide element if screen width is less than 500
            }
        });
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
